'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actions", "children", "open", "openAtColumnIndex", "TH", "TR"];
import PropTypes from 'prop-types';
import { Component, Children } from 'react';
import styled from 'styled-components';
import { TABLE_DEFAULT_FONT_SIZE } from 'HubStyleTokens/sizes';
import { FONT_FAMILIES, setFontSize } from '../utils/Styles';
import { jsx as _jsx } from "react/jsx-runtime";
const ActionsRowTR = styled.tr.withConfig({
  displayName: "UITableActionsRow__ActionsRowTR",
  componentId: "sc-11qd2h2-0"
})(["position:relative;"]);
const ActionsRowTH = styled.th.withConfig({
  displayName: "UITableActionsRow__ActionsRowTH",
  componentId: "sc-11qd2h2-1"
})(["&&{", ";", ";padding-right:0;text-transform:none;}"], FONT_FAMILIES.default, setFontSize(TABLE_DEFAULT_FONT_SIZE));
function renderWithActions(TH, actions, children, openAtColumnIndex) {
  const childArray = Children.toArray(children);
  const visibleChildren = childArray.slice(0, openAtColumnIndex);
  return visibleChildren.concat([/*#__PURE__*/_jsx(TH, {
    colSpan: childArray.length - openAtColumnIndex,
    children: /*#__PURE__*/_jsx("div", {
      className: "is--text--help",
      children: actions
    })
  }, "actions")]);
}
export default class UITableActionsRow extends Component {
  render() {
    const _this$props = this.props,
      {
        actions,
        children,
        open,
        openAtColumnIndex,
        TH,
        TR
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(TR, Object.assign({}, rest, {
      role: "presentation",
      "aria-live": "polite",
      children: open ? renderWithActions(TH, actions, children, openAtColumnIndex) : children
    }));
  }
}
UITableActionsRow.displayName = 'UITableActionsRow';
UITableActionsRow.defaultProps = {
  open: false,
  TH: ActionsRowTH,
  TR: ActionsRowTR
};
UITableActionsRow.propTypes = {
  actions: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  open: PropTypes.bool.isRequired,
  openAtColumnIndex: PropTypes.number.isRequired,
  TH: PropTypes.elementType,
  TR: PropTypes.elementType
};